import React from 'react';

const SuccessIcon = () => {

  return (
    <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="22.5" cy="22.5" r="21.5" fill="white" stroke="black" strokeWidth="2" />
      <path fillRule="evenodd" clipRule="evenodd" d="M34.6945 14.4336L32.2676 12.6968L21.0013 29.0627L13.9699 19.601L11.5849 21.3951L19.2982 31.5368L19.287 31.553L21.3269 34.2052L21.3272 34.2047L21.3275 34.2051L21.3289 34.2022L34.6945 14.4336Z" fill="#00A524" />
    </svg>
  );

};

export default SuccessIcon;
